let checkSwipeIsLive: number | undefined;

export const swipeGesture = (navigate: (dir: 'prev' | 'next') => void) => {
  return e => {
    const { currentTarget } = e;
    const x = e.touches[0].clientX;

    let pointerTravel = 0;
    let swipeIsLive = true;

    clearTimeout(checkSwipeIsLive);
    checkSwipeIsLive = window.setTimeout(() => {
      swipeIsLive = false;
    }, 300);

    const onTouchMove = e => {
      // get mouse travel
      pointerTravel = e.touches[0].clientX - x;
    };

    const onTouchEnd = e => {
      if (swipeIsLive) {
        if (pointerTravel > 10) {
          // console.log('swipe prev !!!');
          navigate('prev');
        }

        if (pointerTravel < -10) {
          // console.log('swipe next !!!');
          navigate('next');
        }
      }
      //
      currentTarget.removeEventListener('touchmove', onTouchMove);
      currentTarget.removeEventListener('touchend', onTouchEnd);
    };
    //
    currentTarget.addEventListener('touchmove', onTouchMove);
    currentTarget.addEventListener('touchend', onTouchEnd);
  };
};
